import { useHistory } from "react-router";
//Styles and Icons
import ArrowBackIcon from "../../styles/icon/arrow_back_fill.svg";
import styles from "./NotFound.module.scss";
import NotFoundPic from "../../styles/pics/404.svg";
export default function NotFound() {
  const history = useHistory();
  return (
    <section className={styles.container}>
      <div className={styles.BackArrow}>
        <img
          src={ArrowBackIcon}
          alt="BACK"
          width={15}
          height={15}
          onClick={() => history.goBack()}
        />
      </div>
      <div>404</div>
      <div>اوه! ببخشید!</div>
      <div>چیزی که دنبالش میگردی اینجا نیست</div>
      <div>
        <img src={NotFoundPic} alt="" width="100%" />
      </div>
      <button onClick={() => history.replace("/")}>بازگشت به صحفه اصلی</button>
    </section>
  );
}
